import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import {
  fetchEarningSummaryStart,
} from "../../../../store/actions/WalletAction";

import "./styles/cards.css";
import { statsSummaryColors } from "../../PerformerStatements/EarningStats";

export default function SummaryCards() {
  const walletSummary = useSelector((state) => state.wallet.earningSummary);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchEarningSummaryStart());
  }, []);
  return (
    <>
      <div className={`cards-summary-container last-card-margin`}>
        <div className={`statement-card-summary`}>
          <div className="statement-card-body-summary">
            {walletSummary?.data?.stats?.map((stats, index) => (
              <div className="w-100 d-flex justify-content-between summary-cell">
                <div className="d-flex flex-row align-items-center">
                  <span
                    className={`d-flex dot bg-color-${statsSummaryColors[index]}`}
                  ></span>{" "}
                  <p className="statement-text-title">{stats.usage_type}</p>{" "}
                </div>
                <p className="statement-text-data">
                  {stats.net_amount_formatted}{" "}
                </p>
              </div>
            ))}

            <div
              className={`w-100 d-flex justify-content-between mt-1 summary-cell`}
            >
              <p className="statement-text-title">Total</p>{" "}
              <p className="statement-text-data">
                {" "}
                <span>NET: </span> {walletSummary.data.total.net_amount}{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
